<template>
  <div>
   <div class="detail-page-title">
      查看子任务
      <a-button class="setwz" type="primary" @click="goBack()">返回</a-button>
    </div>
    <TagSubTask></TagSubTask>
    <!--<a-tabs>
      <a-tab-pane key="1" tab="标注子任务">
      </a-tab-pane>
      <a-tab-pane key="2" tab="审核子任务">
        <ReviewSubTask></ReviewSubTask>
      </a-tab-pane>
    </a-tabs>-->
    <!--<div class="filter-section">
      <span>状态:</span>
      <a-select
        style="width: 140px"
        v-model:value="form.state"
      >
        <a-select-option key="全部" value="" title="全部">
          全部
        </a-select-option>
        <a-select-option key="未分配">
          未分配
        </a-select-option>
        <a-select-option key="已分配">
          已分配
        </a-select-option>
        <a-select-option key="标注中">
          标注中
        </a-select-option>
        <a-select-option key="审核中">
          审核中
        </a-select-option>
        <a-select-option key="已完成">
          已完成
        </a-select-option>
      </a-select>
      <a-input style="width: 200px" placeholder="请输入名称" v-model:value="form.filterText">
        <template v-slot:suffix><search-outlined type="user"/></template>
      </a-input>
    </div>-->
  </div>
</template>
<script>
// import { SearchOutlined } from '@ant-design/icons-vue'
import TagSubTask from './TagSubTask'
// import ReviewSubTask from './ReviewSubTask'
export default {
  components: {
    TagSubTask
    // ReviewSubTask
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  }
}
</script>
<style lang="less">
.setwz{
  margin-left:10px;
}
</style>
